import { createContext, Provider, useContext } from "react";

import {
  BreakpointStore,
  BudgetStore,
  ChatStore,
  ContentManagementStore,
  GlobalErrorsStore,
  NavigationStore,
  SettingsStore,
  SidebarStore,
  StreamingChatStore,
  SummaryStore,
  ThreadStore,
  TranscriptionStore,
  UserStore,
  WhitelabelStore,
} from ".";
import GlossaryStore from "./GlossaryStore";
import { ImageGenerationStore } from "./ImageGenerationStore";
import { PermissionStore } from "./PermissionStore";
import { SpoContentManagementStore } from "./SpoContentManagementStore";
import { ToastStore } from "./ToastStore";
import TranslationStore from "./TranslationStore";

export interface IStoreContext {
  breakpointStore: BreakpointStore;
  budgetStore: BudgetStore;
  chatStore: ChatStore;
  contentManagementStore: ContentManagementStore;
  spoContentManagementStore: SpoContentManagementStore;
  globalErrorsStore: GlobalErrorsStore;
  navigationStore: NavigationStore;
  settingsStore: SettingsStore;
  sidebarStore: SidebarStore;
  streamingChatStore: StreamingChatStore;
  summaryStore: SummaryStore;
  threadStore: ThreadStore;
  imageGenerationStore: ImageGenerationStore;
  transcriptionStore: TranscriptionStore;
  userStore: UserStore;
  whitelabelStore: WhitelabelStore;
  permissionStore: PermissionStore;
  toastStore: ToastStore;
  translationStore: TranslationStore;
  glossaryStore: GlossaryStore;
}

export const store: IStoreContext = {
  breakpointStore: new BreakpointStore(),
  budgetStore: new BudgetStore(),
  chatStore: new ChatStore(),
  contentManagementStore: new ContentManagementStore(),
  spoContentManagementStore: new SpoContentManagementStore(),
  globalErrorsStore: new GlobalErrorsStore(),
  navigationStore: new NavigationStore(),
  settingsStore: new SettingsStore(),
  sidebarStore: new SidebarStore(),
  streamingChatStore: new StreamingChatStore(),
  summaryStore: new SummaryStore(),
  threadStore: new ThreadStore(),
  imageGenerationStore: new ImageGenerationStore(),
  transcriptionStore: new TranscriptionStore(),
  userStore: new UserStore(),
  whitelabelStore: new WhitelabelStore(),
  permissionStore: new PermissionStore(),
  toastStore: new ToastStore(),
  translationStore: new TranslationStore(),
  glossaryStore: new GlossaryStore(),
};

let storeContext: any;
let storeContextProvider: any;

const getStoreContext = () => {
  if (!storeContext) {
    storeContext = createContext(store);
  }

  return storeContext;
};

export const getStoreContextProvider = (): Provider<IStoreContext> => {
  if (!storeContextProvider) {
    storeContextProvider = getStoreContext().Provider;
  }

  return storeContextProvider;
};

export function useStore(): IStoreContext {
  return useContext(getStoreContext());
}
